export enum AdministrationTab {
  MAINTENANCE = 'maintenance',
  ROLES = 'roles',
  USERS = 'users',
}

export const ADMINISTRATION_TAB_PARAM = 'tab';
export const ADMINISTRATION_ROLE_PARAM = 'role';
